/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Dlaczego pytający nie widzi oferty na kalendarzu. `STATUS` — ten status nie wchodzi na jego kalendarz (albo nie wchodzi nigdy, jak anulowana). `NOT_PROCESS_OWNER` — status widzi tylko opiekun procesu, a pytający nim nie jest. Pozostałe trzy mówią o samej ofercie: brak obu terminów wydarzenia, brak klienta na procesie, szablon oferty predefiniowanej. 
 */

export const OfferCalendarHiddenReasonDto = {
    Status: 'STATUS',
    NotProcessOwner: 'NOT_PROCESS_OWNER',
    MissingEventDates: 'MISSING_EVENT_DATES',
    MissingCustomer: 'MISSING_CUSTOMER',
    Template: 'TEMPLATE',
} as const;

export type OfferCalendarHiddenReasonDto = typeof OfferCalendarHiddenReasonDto[keyof typeof OfferCalendarHiddenReasonDto];



